import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { IconCheck } from '@wds/icons';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const COPY = defineMessages({
  THANK_YOU: {
    id: 'SurveyThanks.NonBranded.ThankYou',
    defaultMessage: 'Thank you for taking the survey.',
    description:
      '[Type: Header][vis: high] - The only message on the webpage. Used on a Nonbranded webpage to say thank you to survey respondents and signal the end of the survey.',
  },
});

const useStyles = createUseStyles((theme: CmsWrenchTheme) => {
  return {
    container: {
      height: theme.util.fullHeight,
    },
  };
});

function NonBranded(): React.ReactElement {
  const classes = useStyles();

  return (
    <Box className={classes.container} display="flex" flexAlign="center" flexJustify="center" flexDirection="column">
      <Box display="inline-flex">
        <IconCheck color="dark" size="md" title="" />
        <Typography color="dark" component="div" variant="body">
          {t(COPY.THANK_YOU)}
        </Typography>
      </Box>
    </Box>
  );
}

export default NonBranded;
